import { AufnahmePunktDocument, SubstratZeile } from "src/app/data-model";
import { EvalFunc } from "../evaluation.service";
import { angezeigteTiefe, filzVersatz } from "../filz-tiefen";

/**
 * Karbonattiefe = Oberkante der ersten karbonathaltigen Substratschicht.
 *
 * Bei einem Filz (filz-tiefen.ts) zaehlt sie ab Oberkante Ol: Die Oberkante
 * der ersten Schicht liegt dann nicht bei 0, sondern unter der Auflage
 * (Nutzer-Entscheidung 25.09.2026, „alles nachziehen"). Gerechnet wird weiter
 * mit den eingegebenen Tiefen, verschoben wird nur das Ergebnis.
 */
export const karbonatEval: EvalFunc = (bp: any) => {
    const b = bp as AufnahmePunktDocument;
    if (!b.Substratfolge || b.Substratfolge.length === 0) return undefined;

    const index = b.Substratfolge.findIndex((s: SubstratZeile) => s.karbonatgehalt !== undefined && s.karbonatgehalt > 0);
    if (index < 0) return undefined;
    const versatz = filzVersatz(b);
    if (index === 0) return versatz;
    return angezeigteTiefe(b.Substratfolge[index - 1].tiefe, versatz);
};

